const baseURL = 'https://almacenmexico.appboutique.click/';

export default baseURL;
